import { useEffect, useRef, useState } from 'react'

import { Tooltip } from '@joor/design-system'

import { DetailValue as StyledDetailValue } from '../../header.ui'

export default function DetailValue({
  children,
  testId,
}: {
  children: React.ReactNode
  testId?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [, setForceRerender] = useState(false)

  const shouldDisplayTooltip =
    !!ref.current && ref.current.scrollHeight > ref.current.clientHeight

  useEffect(() => {
    const handleResize = () => setForceRerender((prevState) => !prevState)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return shouldDisplayTooltip ? (
    <Tooltip content={children} defaultPlacement="bottom">
      <StyledDetailValue ref={ref} data-testid={testId}>
        {children}
      </StyledDetailValue>
    </Tooltip>
  ) : (
    <StyledDetailValue ref={ref} data-testid={testId}>
      {children}
    </StyledDetailValue>
  )
}
